import { getServerURL } from "../shared/sharedFunctions";
import userService from "./userService";
import companyService from "./companyService";

const RagService = () => {
	const pub = {};
	
	pub.rags = [];
	pub.completedRags = [];
	pub.recommendations = [];
	
	pub.all = async (companyId) => {
		let req = {
			method: "GET",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
		};
		
		let response = await fetch(`${getServerURL()}/api/rags/all/${companyId}`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} getting domains`);
		}
		let data = await response.json();
		
		pub.rags = [];
		pub.completedRags = [];
		for (let i in data.rags) {
			const rag = data.rags[i];
			
			rag.description_short = rag.description_short.replaceAll("KYND", "Cymplify");
			rag.description_long = rag.description_long.replaceAll("KYND", "Cymplify");
			data.rags[i].history = data.rags[i].history.replaceAll("KYND", "Cymplify");
			
			rag.history = JSON.parse(data.rags[i].history);
			if (rag.complete === 0) {
				pub.rags.push(rag);
			}
			else {
				pub.completedRags.push(rag);
			}
		}
	}
	
	pub.ragCounts = () => {		
		const ragCounts = { red: 0, amber: 0, green: 0 };
		
		for (let i in pub.rags) {			
			if (pub.rags[i].severity === 2) ragCounts.red += 1;
			else if (pub.rags[i].severity === 1) ragCounts.amber += 1;
			else if (pub.rags[i].severity === 0) ragCounts.green += 1;
		}
		
		return ragCounts;
	};
	
	pub.getRecommendations = async (companyId) => {
		let req = {
			method: "GET",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
		};
		
		let response = await fetch(`${getServerURL()}/api/rags/recommendations/${companyId}`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} getting recommendations`);
		}
		let data = await response.json();
		
		pub.recommendations = data.recommendations;
	};
	
	pub.setComplete = async (ragId, complete, notes) => {
		let req = {
			method: "POST",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			body: JSON.stringify({
				complete: complete,
				notes: notes
			})
		};
		
		let response = await fetch(`${getServerURL()}/api/rags/complete/${ragId}`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} setting rag complete`);
		}
		let data = await response.json();
		
		await pub.all(companyService.selectedCompany.id);
		
		return data.rag;
	};
	
	return pub;
}

export default RagService();